const ProductsConstants = {
  DeploymentTypes: {
    NONE: 'None',
  },
};

export default ProductsConstants;
